var _circle, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarvinIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0004,
    cy: 12.0006,
    r: 12.0004,
    fill: "url(#paint0_linear_4818_2354)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.41716 6.88315C5.17597 6.64089 5.09176 6.28344 5.19946 5.95899L5.22868 5.87093C5.34565 5.51854 5.63905 5.25344 6.00146 5.17269L6.01855 5.16888C6.37788 5.08882 6.75331 5.19603 7.01616 5.45378L11.8679 10.2112L13.1982 8.97252L14.5111 10.2303L12.5772 11.9549C12.3693 12.1403 12.1005 12.2427 11.8219 12.2427C11.5402 12.2427 11.2685 12.1379 11.0598 11.9487L6.57073 7.87972L6.5977 7.90001L5.41716 6.88315Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3414 9.4899L14.0111 8.21556L16.9852 5.44636C17.1912 5.25451 17.4623 5.14785 17.7438 5.14785C18.3587 5.14785 18.8571 5.64628 18.8571 6.26113V17.4372C18.8571 17.9339 18.4544 18.3366 17.9577 18.3366C17.4615 18.3366 17.0591 17.9349 17.0582 17.4388L17.0413 7.97395L15.3414 9.4899Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.98368 16.8884C7.98368 16.789 7.97347 16.692 7.95405 16.5984L9.21052 15.2561C9.37589 15.3235 9.5568 15.3606 9.74639 15.3606C10.5309 15.3606 11.1668 14.7247 11.1668 13.9402C11.1668 13.1557 10.5309 12.5198 9.74639 12.5198C9.57348 12.5198 9.40779 12.5506 9.25453 12.6072L7.97065 11.3233C7.97924 11.2602 7.98368 11.1957 7.98368 11.1301C7.98368 10.3457 7.34773 9.70971 6.56325 9.70971C5.77877 9.70971 5.14282 10.3457 5.14282 11.1301C5.14282 11.6188 5.38957 12.0498 5.76526 12.3054L5.76527 15.7132C5.38957 15.9687 5.14282 16.3998 5.14282 16.8884C5.14282 17.6729 5.77877 18.3089 6.56325 18.3089C7.34773 18.3089 7.98368 17.6729 7.98368 16.8884ZM7.10967 11.1301C7.10967 11.4319 6.86503 11.6766 6.56325 11.6766C6.26147 11.6766 6.01683 11.4319 6.01683 11.1301C6.01683 10.8284 6.26147 10.5837 6.56325 10.5837C6.86503 10.5837 7.10967 10.8284 7.10967 11.1301ZM6.94035 12.5L6.94036 15.5186C7.04531 15.5474 7.14541 15.588 7.23914 15.6388L8.40115 14.3974C8.3524 14.2539 8.32596 14.1001 8.32596 13.9402C8.32596 13.7626 8.35856 13.5926 8.41808 13.4359L7.31669 12.3345C7.20132 12.4068 7.07482 12.463 6.94035 12.5ZM9.74639 14.4866C9.62305 14.4866 9.50925 14.4457 9.4178 14.3768L9.32966 14.2936C9.24877 14.1983 9.19998 14.075 9.19998 13.9402C9.19998 13.6384 9.44462 13.3938 9.74639 13.3938C10.0482 13.3938 10.2928 13.6384 10.2928 13.9402C10.2928 14.242 10.0482 14.4866 9.74639 14.4866ZM6.56325 17.4348C6.86503 17.4348 7.10967 17.1902 7.10967 16.8884C7.10967 16.5866 6.86503 16.342 6.56325 16.342C6.26147 16.342 6.01683 16.5866 6.01683 16.8884C6.01683 17.1902 6.26147 17.4348 6.56325 17.4348Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4818_2354",
    x1: 2.59002,
    y1: -6.99283,
    x2: 25.9192,
    y2: 3.77741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00148221,
    stopColor: "#51087E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473958,
    stopColor: "#A14653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB8B23"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarvinIcon);
export default __webpack_public_path__ + "static/media/MarvinIcon.1b292ad7915205cccf9456658a5d47a6.svg";
export { ForwardRef as ReactComponent };